import { useEffect, useState } from 'react'
import { useByStudent } from '../ByStudentContext/ByStudentContext'
import { useSelector } from 'react-redux'
import LGDistributionUL from './LGDistributionUL'
import NoResultsContainer from '../NoResults/NoResults'
import DialogLcs from './Dialog'

const ByUnitOfLearning = () => {
  const { studentSelected, curriculumId, loading, learningMatrix, byUL, onLoadByUL, currentCurriculum } =
    useByStudent()
  const state = useSelector((state) => state?.filter?.learningMatrix || {})
  const [lcs, setLcs] = useState([])
  const [lgType, setLgType] = useState([])
  const [dialog, setDialog] = useState(null)
  const size = 35

  useEffect(() => {
    if (curriculumId && studentSelected) {
      onLoadByUL(curriculumId, studentSelected, state.filter)
    }
  }, [curriculumId, studentSelected, state.filter])

  useEffect(() => {
    const newLCS =
      learningMatrix?.lcs?.filter((lc) => {
        if (lgType.length === 0) return true
        return lgType.includes(lc.lgType)
      }) || []
    setLcs(newLCS || [])
  }, [learningMatrix?.lcs, lgType])

  const onFilter = (type) => {
    if (lgType.includes(type)) {
      setLgType([])
    } else {
      setLgType([type])
    }
  }

  if (!studentSelected) {
    return <NoResultsContainer />
  }

  return (
    <>
      {/* <div
        className={[
          'sticky inset-x-0 top-0px h-180px bg-background z-22',
          loading ? 'overflow-hidden' : ''
        ].join(' ')}
      >
        <LGDistribution
          loading={loading}
          uls={byUL.uls}
          onFilter={onFilter}
          lgType={lgType}
          keyName={'Units of learning'}
        />
      </div> */}
      <LGDistributionUL
        top={0}
        maxLevel={byUL.maxLevel}
        uls={byUL.uls || []}
        completed={'completedTeacher'}
        currentCurriculum={currentCurriculum || {}}
        loading={loading}
        onMoreInfo={(ul) => setDialog(ul)}
      />
      {dialog && (
        <DialogLcs
          data={dialog}
          show={!!dialog}
          onClose={() => setDialog(false)}
          lcs={lcs}
          currentCurriculum={currentCurriculum || {}}
          size={size}
        />
      )}
    </>
  )
}

export default ByUnitOfLearning
